<input
  *ngIf="!multiple"
  #fileUpload
  type="file"
  class="file-input"
  (change)="onFileChange($event)" />
<input
  #fileUpload
  *ngIf="multiple"
  type="file"
  class="file-input"
  (change)="onFileChange($event)"
  multiple />
<div
  [ngClass]="[
    'file-upload',
    'style-' + style,
    'p-3',
    'text-center',
    isUploading ? 'disabled' : '',
    dropzoneActive ? 'dropzone' : '',
    style == styles.EVIDENCE ? 'rounded' : ''
  ]"
  (dragleave)="($event.preventDefault); toggleDropZone(false); (false)"
  (dragover)="($event.preventDefault); toggleDropZone(true); (false)"
  (dragend)="($event.preventDefault); toggleDropZone(false); (false)"
  (drop)="handleDrop($event); (false)"
  (click)="onUploadButtonClick()">
  <app-file-list></app-file-list>
  <p
    [ngClass]="[
      style == styles.SIMPLE || style == styles.EVIDENCE
        ? 'color-dark-gray'
        : 'color-primary',
      'fw-bold'
    ]">
    Click here or drag file<span *ngIf="multiple">(s)</span> here to upload
  </p>
  <div *ngIf="style == styles.FANCY" class="btn btn-primary">
    <i class="bi bi-file-upload"></i>Upload
  </div>
  <div
    *ngIf="style == styles.SIMPLE || style == styles.EVIDENCE"
    class="btn btn-tertiary">
    <i class="bi bi-upload"></i>
  </div>
</div>
<ng-container *ngIf="errorMsg">
  <ngb-alert [type]="'danger'">{{ errorMsg }}</ngb-alert>
</ng-container>
<div *ngIf="uploadingItems" class="uploadItems">
  <div class="row" *ngFor="let item of uploadingItems | keyvalue">
    <div class="col-xs-12">
      {{ item.value.name }}
      <ngb-progressbar
        [value]="item.value.progress"
        [animated]="true"></ngb-progressbar>
    </div>
  </div>
</div>
